// import { showSuccess, showError } from '../../index.js'

export default {
  namespaced: true,
  state () {
    return {
      groupPermissions: []
    }
  },
  getters: {
    backendGroupPermissions (state) {
      return [...state.groupPermissions].sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  mutations: {
    setGroupPermissions (state, payload) {
      state.groupPermissions = payload
    }
  },
  actions: {
    async getGroupPermissionsData (context) {
      await context.rootState.authAxios.get('/GroupPermission/get').then((response) => {
        context.commit('setGroupPermissions', response.data)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    }

  }
}
